import { AppData } from '@lightningjs/sdk';
import { LoginRadiusError } from 'types/loginRadius';

/**
 * if error is one of the field level errors
 * 966 (Invalid user ID and/or password),
 * 1205 (Invalid Password) or
 * 908 (A parameter is not formatted correctly)
 * 0 Client side error (invalid field passed to API service)
 */
export const isFieldLevelValidationError = (error: LoginRadiusError) => {
  if (!error) return false;

  return (
    error.ErrorCode === 966 ||
    error.ErrorCode === 1205 ||
    error.ErrorCode === 908 ||
    error.ErrorCode === 0
  );
};

export const getQrCodeUrl = (code?: string) => {
  if (!code) return '';

  const url = AppData!.config?.login.endpoints.templates.qr_template
    .replace(/{{WEB_URL}}/g, AppData!.config?.login.endpoints.web_login ?? '')
    .replace(/{{CODE}}/g, code)
    .replace(/([^:]\/)\/+/g, '$1'); // Removes consecutive slashes (except https://) due to config constraints

  return url ?? '';
};
